import { useRouteError } from "react-router-dom";

export function GlobalErrorElement({ error, resetErrorBoundary }) {
  const routeError = useRouteError();
  const message =
    error?.message || routeError?.statusText || "Something went wrong!";

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="w-full max-w-md rounded-lg bg-card p-8 text-card-foreground shadow-md">
        <h1 className="mb-4 text-2xl font-bold text-destructive">Oops!</h1>
        <p className="mb-4 text-muted-foreground">{message}</p>
        <div className="flex gap-4">
          <button
            onClick={() => (window.location.href = "/")}
            className="rounded bg-primary px-4 py-2 text-primary-foreground transition-colors hover:bg-primary/90"
          >
            Go Home
          </button>
          {resetErrorBoundary && (
            <button
              onClick={resetErrorBoundary}
              className="rounded bg-secondary px-4 py-2 text-secondary-foreground transition-colors hover:bg-secondary/80"
            >
              Try Again
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default GlobalErrorElement;
